const Juice = (props) => (
  <svg
    fill="#ffffff"
    height="30px"
    width="30px"
    viewBox="0 0 297.5 297.5"
    xmlSpace="preserve"
    {...props}
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0" />
    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
    <g id="SVGRepo_iconCarrier">
      <g>
        <path d="M266.917,74.5c0-31.98-26.019-57.999-57.999-57.999c-29.266,0-53.523,21.792-57.435,49.999h-34.131L102.864,6.132 c-0.552-2.298-2.091-4.234-4.206-5.29c-2.114-1.057-4.587-1.121-6.756-0.183l-56.5,24.5c-4.054,1.758-5.915,6.469-4.157,10.522 c1.758,4.053,6.471,5.913,10.522,4.157l47.761-20.711L100.897,66.5H84.665c-2.191,0-4.286,0.898-5.796,2.486 c-1.511,1.587-2.304,3.725-2.194,5.912l10.732,215c0.213,4.259,3.727,7.602,7.99,7.602h103.039c4.264,0,7.777-3.343,7.99-7.602 l7.871-157.658C243.765,129.515,266.917,104.666,266.917,74.5z M200.762,82.5l-0.849,17H93.923l-0.849-17H200.762z" />
      </g>
    </g>
  </svg>
);

export default Juice;
